import gql from "graphql-tag";

const GET_ACTIVITY_FEED = gql`
  query getActivityFeed(
    $limit: Int
    $pageNum: Int
    $filter: activityFeedFilter
  ) {
    getActivityFeed(
      limit: $limit
      pageNum: $pageNum
      filter: $filter
    ) {
      activityReports {
        id
        activity_type
        activity_datetime
        csm {
          first_name
          last_name
        }
        customer_name
        customer_email
        customer_phone
        is_traffic_activity
        customer_types {
          name
        }
        communities {
          name
        }
        customer_origination_area {
          name
        }
        activity_title
        appointment_type
        email_id
        subject
        lead_id
        prospect_id
        marketing_only_id
      }
      total_count
    }
  }
`;

export default GET_ACTIVITY_FEED;
